import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

const buildVersion = process.env.REACT_APP_BUILD_VERSION;


i18n
  // load translation using http   
  .use(Backend)
  // detect user language  
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next   
  .init({
    fallbackLng: 'en',    
    debug: false,
    backend: {
      loadPath: `${process.env.REACT_APP_DEPLOY_PATH}/locales/{{lng}}/translation.json?v=${buildVersion}`
    },
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    }
  });


export default i18n;